import React from 'react';

import useTable from '../useTable';

function Footer({mailBox, setMailBox, children}) {
  const { copyDivToClipboard, codeCopy, copySuccess} =  useTable();

    return (
    <>
      <div className='content-header'>
        <p className='content-header--text'>
          <span className='content-header--small'>Prawie gotowe!</span>
          <br/>Upewnij się, że dane są dobrze wprowadzone.
          <br/>Skopiuj podgląd stopki i umieść ją w podpisie swojego maila:
        </p>

      {document.queryCommandSupported('copy') && (
        <div className="modal-content">
          {/* mailbox nav */}
          <div className="mail-tabs">
            <div className="buttonwrap">
              <button className={(mailBox === "gmail") ? 'smallBtn tabActive' : 'smallBtn'} onClick={(e) => setMailBox('gmail')}>
                gmail
              </button>
            </div>
            <div className="buttonwrap">
              <button className={(mailBox === "thunderbird") ? 'smallBtn tabActive' : 'smallBtn'} onClick={(e) => setMailBox('thunderbird')}>
                thunderbird
              </button>
            </div>
            <div className="buttonwrap">
              <button className={(mailBox === "outlook") ? 'smallBtn tabActive' : 'smallBtn'} onClick={(e) => setMailBox("outlook")}>
                outlook
              </button>
            </div>
          </div>

          {/* company footer */}
          {children}

          {/* copy buttons */}
          <div className="mail-copy">
            {(mailBox === "thunderbird") ? (
              <div className="buttonwrap">
                <button className="smallBtn" onClick={() => codeCopy()}>
                  {copySuccess ? <span>{copySuccess}</span> : 'skopiuj kod stopki'}
                </button>
              </div>
            ) : (
              <div className="buttonwrap">
                <button className="smallBtn" onClick={() => copyDivToClipboard()}>
                  {copySuccess ? <span>{copySuccess}</span> : 'skopiuj stopkę'}
                </button>
              </div>
            )}
          </div>

        </div>
       )}

        {/* HELPER */}
        {(mailBox === "gmail") ? (
          <div className='content-helper helper-footer'>
            <h4>
              Zobacz jak łatwo możesz dodać stopkę w Gmail!
            </h4>
            <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
            <a href="https://support.google.com/mail/answer/8395?hl=pl&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">TUTAJ</a>
            &nbsp;znajdziesz szczegółowe informacje jak umieścić stopkę w Gmail.</p>
            <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
              W skrócie, przejdź do: <span className="intruction">Gmail</span> &gt; <span className="intruction">Ustawienia</span> &gt; <span className="intruction">Wszystkie ustawienia</span> &gt; <span className="intruction">Podpis</span></p>
          </div>
        ) : (mailBox === "thunderbird") ? (
          <div className='content-helper helper-footer'>
            <h4>
              Przeczytaj jak dodać stopkę w Thunderbird!
            </h4>
            <p><span role="img" aria-label="light bulb">🚨</span>&nbsp;
            <strong>Uważaj!</strong> Kopiując stopkę z tej zakładki, kopiujesz kod HTML. 
            <br/>Przy wklejaniu podpisu w Thunderbird, upewnij się, że wybrałeś opcję "Używaj HTML".</p>
            <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
            <a href="https://support.mozilla.org/pl/kb/sygnatury" target="_blank" rel="noreferrer">TUTAJ</a> znajdziesz dalsze instrukcje.
            </p>
            <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
              W skrócie: <span className="intruction">Narzędzia/(lub kliknij w nazwę swojego maila)</span> &gt; 
              <br/><span className="intruction">Konfiguracja/Ustawienia</span> &gt; <span className="intruction">Sygnaturka: (zaznacz 'Używaj HTML')</span>
            </p>
          </div>
        ) : (mailBox === "outlook") ? (
          <div className='content-helper helper-footer'>
            <h4>
              Tak umieścisz stopkę w Microsoft Outlook!
            </h4>
            <p><span role="img" aria-label="light bulb">💡</span> Znajdź szczegółowe instukcje, klikając w&nbsp;
            <a href="https://support.microsoft.com/pl-pl/office/tworzenie-i-dodawanie-podpisu-do-wiadomo%C5%9Bci-8ee5d4f4-68fd-464a-a1c1-0e1c80bb27f2#ID0EBBF=Newer_versions" target="_blank" rel="noreferrer">TEN LINK.</a></p>
            <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
            <strong>TIP:</strong> Jeśli masz kłopot spóbuj znaleźć zakładkę wiadomość lub nowa wiadomość 
            <br/>a w niej opcję Podpis &gt; Podpisy.
            Możesz też poszukać ogólnych opcji a w nich zakładkę Poczta.</p>
            <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
              Spróbuj: <span className="intruction">Plik</span> &gt; <span className="intruction">Opcje</span> &gt; <span className="intruction">Poczta</span> &gt; <span className="intruction">Podpisy(przycisk po lewej stronie)</span>
              <br/>Lub: <span className="intruction">Wiadomości/Nowa Wiadomość</span> &gt; <span className="intruction">Podpis</span> &gt; <span className="intruction">Podpisy...</span>
            </p>
          </div>
        ) : (
            <></>
        )}

      </div>
    </>
    );
}

export default Footer;